import { withMotion } from '@hoc/withMotion';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import ReactPlayer from 'react-player';
import Icon from '../Icon/Icon';
import S from './VideoModal.styles';
const VideoModal = ({ isVisible = false, closeBtnTxt, src, onClick, }) => {
    const refModal = React.useRef(null);
    React.useEffect(() => {
        function checkIfClickedOutside(e) {
            if (isVisible && refModal.current && !refModal.current.contains(e.target)) {
                onClick();
            }
        }
        document.addEventListener('click', checkIfClickedOutside);
        return () => {
            document.removeEventListener('click', checkIfClickedOutside);
        };
    }, [isVisible]);
    if (!src) {
        return null;
    }
    return (React.createElement(AnimatePresence, null, isVisible && (React.createElement(S.Container, { key: "modal", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } },
        React.createElement(S.VideoHolder, null,
            React.createElement(S.VideoInner, null,
                React.createElement(S.VideoContainer, { ref: refModal },
                    React.createElement(S.CloseBtn, { type: "button", onClick: () => onClick() },
                        React.createElement(Icon, { icon: "cross" }),
                        React.createElement("span", null, closeBtnTxt)),
                    React.createElement(S.VideoWrapper, null,
                        React.createElement(ReactPlayer, { url: src, playing: isVisible, controls: true, playsinline: true, width: "100%", height: "100%" })))))))));
};
export default withMotion(VideoModal);
